import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  Label,
  Row,
  Col,
  Table,
  Badge,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import TableScrollbar from "react-table-scrollbar";
import moment from "moment";
import "../../Material/MaterialRequest.scss";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import {
  getReqestRowDetails,
  productItemHistoryModelOpen,
} from "../../../store/ServiceRequest/actions";

import LoadingModel from "../../LoadingModel";
import ItemDetails from "../../ItemDetails";
import ProductItemHistoryLog from "../../Material/ProductItemHistoryLog";

function PdfViewer({ url }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        let finalUrl = url;

        if (
          window.location.hostname === "localhost" &&
          url.startsWith("http://vendpin.dev.absol.in")
        ) {
          finalUrl = url.replace("http://vendpin.dev.absol.in", "");
        }

        const response = await fetch(finalUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      }
    };
    fetchPdf();
  }, [url]);

  if (!pdfBlobUrl)
    return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

  return (
    <iframe
      src={pdfBlobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}
class MyServiceRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      reqStateRowData: {},
      request_items: [],
      item_details: {},
      selectedOrderLocation: null,
      showImageModal: false,
    };

    this.tog_static = this.tog_static.bind(this);
  }
  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));

    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount() {
    this.props.getReqestRowDetails(this.props.match.params.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <AvForm className="needs-validation">
              <Row>
                <Col md={12}>
                  <Card>
                    <CardHeader className="bg-transparent border-bottom ">
                      <Link
                        to="/srdashboard1"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>

                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Service Request
                      </h5>
                      <div className="float-right">
                        <div className="d-inline-block ">
                          <Link
                            to={"/srreportdoc/" + this.props.match.params.id}
                            className="action-icon text-primary mr-2"
                          >
                            <Button
                              type="button"
                              outline
                              color="secondary"
                              className=" mr-2"
                            >
                              <i className="mdi  mdi-printer"></i>
                              <span className="d-none d-inline-block ml-1">
                                Print
                              </span>
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-1 ">
                      <Row className="p-1">
                        <Col xl={4} className="p-1">
                          <Card className="p-1 bg-light">
                            <CardHeader
                              className="bg-transparent"
                              style={{
                                borderBottom: "1px solid #d9d9d9",
                              }}
                            >
                              <h3 className="card-title-15">
                                REQUEST DETAILS (
                                <span>
                                  <b>{this.props.srRowData.code}</b>
                                </span>
                                )
                              </h3>
                            </CardHeader>
                            <CardBody className="pt-1 bg-light">
                              <Row className="p-0">
                                <Col md="12" className="p-1 m-0">
                                  <div className="Order-panel-content">
                                    <div className="list-column">
                                      <ul className="list-style-three p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            SR Issue status:
                                          </span>
                                          <span className="dtl">
                                            {this.props.srRowData.srstatus ===
                                              4 ||
                                            this.props.srRowData.srstatus ===
                                              6 ? (
                                              <>
                                                {this.props.srRowData
                                                  .srstatus === 4 && (
                                                  <span>HOD Rejected</span>
                                                )}
                                                {this.props.srRowData
                                                  .srstatus === 6 && (
                                                  <span>Admin Rejected</span>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {
                                                  this.props.srRowData
                                                    .mistatus_name
                                                }
                                              </>
                                            )}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">Location:</span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.location
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Sub Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.sublocation
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Order Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.orderlocation
                                                ?.name
                                            }

                                            {this.props.srRowData.orderlocation
                                              ?.image && (
                                              <Button
                                                color="info"
                                                size="sm"
                                                className="ml-2"
                                                onClick={() =>
                                                  this.setState({
                                                    selectedOrderLocation:
                                                      this.props.srRowData
                                                        .orderlocation,
                                                    showImageModal: true,
                                                  })
                                                }
                                              >
                                                View
                                              </Button>
                                            )}
                                          </span>
                                        </li>
                                        {/* <li className="clearfix">
                                          <span className="ttl">
                                            Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.department
                                                ?.name
                                            }
                                          </span>
                                        </li> */}
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData
                                                .userdepartment?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Name:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.createdby
                                                ?.fullname
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Submited Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.srRowData.createdon
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Required Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.srRowData.date
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Description:
                                          </span>
                                          <span className="dtl">
                                            {this.props.srRowData.description}
                                          </span>
                                        </li>

                                        {(this.props.srRowData.srstatus === 4 ||
                                          this.props.srRowData.srstatus ===
                                            6) && (
                                          <li className="clearfix">
                                            <span className="ttl text-danger ">
                                              Reject Remark :
                                            </span>
                                            <span className="dtl">
                                              {
                                                this.props.srRowData
                                                  .mr_approvals[
                                                  this.props.srRowData
                                                    .mr_approvals.length - 1
                                                ].description
                                              }
                                            </span>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  {(this.props.srRowData.srstatus === 1 ||
                                    this.props.srRowData.srstatus === 2) && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-primary">
                                        Pending
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.srRowData.srstatus === 3 && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-success">
                                        HOD Approved
                                      </Label>
                                    </div>
                                  )}

                                  {(this.props.srRowData.srstatus === 5 ||
                                    this.props.srRowData.srstatus === 7 ||
                                    this.props.srRowData.srstatus === 8) && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-success">
                                        Admin Approved
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.srRowData.srstatus === 4 && (
                                    <div className="text-center ">
                                      <Label className="font-size-24  text-danger">
                                        HOD Rejected
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.srRowData.srstatus === 6 && (
                                    <div className="text-center ">
                                      <Label className="font-size-24  text-danger">
                                        Admin Rejected
                                      </Label>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={12} xl={this.state.showImageModal ? 5 : 8}>
                          <Card className="p-1">
                            <CardBody className="pt-1">
                              <Row>
                                <Col md={12}>
                                  <h3 className="card-title-15 pt-2">
                                    Request Items List
                                  </h3>
                                </Col>
                              </Row>
                              <Row className="p-0">
                                <Col md={12} className="m-1">
                                  <div className="table-responsive m-0">
                                    <TableScrollbar height="400px">
                                      <Table
                                        striped
                                        bordered
                                        hover
                                        className="mb-0 p-0 table-centered"
                                      >
                                        <thead className="bg-light text-center">
                                          <tr>
                                            <th className="nowrap">
                                              Item Images
                                            </th>
                                            <th
                                              style={{
                                                minWidth: "220px",
                                              }}
                                            >
                                              Item Name
                                            </th>
                                            <th className="nowrap">Quantity</th>
                                            <th className="nowrap">
                                              Approved Quantity
                                            </th>
                                            <th className="nowrap">
                                              Item Issue
                                            </th>
                                            <th className="nowrap">Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.props.srRowData?.sritems?.map(
                                            (item, key) => (
                                              <tr key={key}>
                                                <td className="text-center">
                                                  <div className="product-detail text-center">
                                                    <img
                                                      src={
                                                        item?.product?.image ==
                                                        null
                                                          ? DefaultImg
                                                          : item?.product?.image
                                                      }
                                                      alt="product-img"
                                                      title="product-img"
                                                      className="product-img  img-fluid mx-auto tab-img rounded"
                                                      style={{
                                                        height: "100px",
                                                        width: "150px",
                                                      }}
                                                    />
                                                  </div>
                                                  {/* <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="avatar-sm"
                                                  /> */}
                                                </td>
                                                <td>
                                                  <h5 className="font-size-14 ">
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.tog_static(item);
                                                      }}
                                                      className="text-dark"
                                                    >
                                                      {!item.product.active && (
                                                        <i className="text-danger ri-spam-line mr-1"></i>
                                                      )}
                                                      {item?.product?.name}
                                                    </Link>
                                                    {item.sri_approvals
                                                      .length !== 0 && (
                                                      <>
                                                        <Link
                                                          to="#"
                                                          onClick={() => {
                                                            this.props.productItemHistoryModelOpen(
                                                              item.sri_approvals
                                                            );
                                                          }}
                                                          className="text-dark"
                                                        >
                                                          <i className=" text-primary ri-eye-fill ml-2"></i>
                                                        </Link>
                                                      </>
                                                    )}
                                                    {/* {item.sri_approvals
                                                      .length !== 0 && (
                                                      <>
                                                        {(item.sri_approvals[0]
                                                          ?.srstatus === 9 ||
                                                          item.sri_approvals[0]
                                                            ?.srstatus ===
                                                            10) && (
                                                          <>
                                                            <br />
                                                            <spam className="font-size-12 text-danger">
                                                              ({" "}
                                                              <del>
                                                                {
                                                                  item
                                                                    .sri_approvals[0]
                                                                    ?.f_product
                                                                    .name
                                                                }
                                                              </del>{" "}
                                                              )
                                                            </spam>
                                                          </>
                                                        )}
                                                      </>
                                                    )} */}
                                                  </h5>
                                                  <p className="mb-0">
                                                    Make :{" "}
                                                    <span className="font-weight-medium">
                                                      {item.make}
                                                    </span>
                                                  </p>
                                                  <p className="mb-0">
                                                    Description :{" "}
                                                    <span className="font-weight-medium">
                                                      {item.description}
                                                    </span>
                                                  </p>
                                                  {(item.srstatus === 4 ||
                                                    item.srstatus === 6) && (
                                                    <p className="mb-0">
                                                      <b className="text-danger ">
                                                        Reject Remark :
                                                      </b>{" "}
                                                      <span>
                                                        {
                                                          item.sri_approvals[
                                                            item.sri_approvals
                                                              .length - 1
                                                          ].description
                                                        }
                                                      </span>
                                                    </p>
                                                  )}
                                                </td>
                                                <td className="text-center">
                                                  {item.sri_approvals.length ===
                                                  0
                                                    ? item.qty +
                                                      " " +
                                                      item.unit?.name
                                                    : item.sri_approvals[0]
                                                        .f_qty +
                                                      " " +
                                                      item.sri_approvals[0]
                                                        .f_unit.name}
                                                </td>

                                                <td className="text-center">
                                                  {item.qty} {item.unit?.name}
                                                </td>
                                                <td className="text-center">
                                                  {item.srstatus === 4 ||
                                                  item.srstatus === 6 ? (
                                                    <>
                                                      {item.srstatus === 4 && (
                                                        <span>
                                                          HOD Rejected
                                                        </span>
                                                      )}
                                                      {item.srstatus === 6 && (
                                                        <span>
                                                          Admin Rejected
                                                        </span>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <> {item.mistatus_name}</>
                                                  )}
                                                </td>

                                                <td className="nowrap text-center">
                                                  <Badge
                                                    className="font-size-14"
                                                    color={
                                                      item.srstatus === 1 ||
                                                      item.srstatus === 2
                                                        ? "primary"
                                                        : item.srstatus === 3 ||
                                                          item.srstatus === 5 ||
                                                          item.srstatus === 7 ||
                                                          item.srstatus === 8 ||
                                                          item.srstatus ===
                                                            11 ||
                                                          item.srstatus === 12
                                                        ? "success"
                                                        : "danger"
                                                    }
                                                  >
                                                    {item.srstatus_name}
                                                  </Badge>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    </TableScrollbar>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>

                        {this.state.showImageModal &&
                          this.state.selectedOrderLocation?.image && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>
                                    Order Location Document:{" "}
                                    {this.state.selectedOrderLocation.name}
                                  </h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({
                                        showImageModal: false,
                                      })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {this.state.selectedOrderLocation?.image ? (
                                    (() => {
                                      const rawUrl =
                                        this.state.selectedOrderLocation.image;
                                      const cleanUrl = rawUrl.trim();
                                      const isPdf = /\.pdf(\?.*)?$/i.test(
                                        cleanUrl
                                      );

                                      return isPdf ? (
                                        <PdfViewer url={cleanUrl} />
                                      ) : (
                                        <img
                                          src={cleanUrl}
                                          alt="Order Location"
                                          style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                          }}
                                        />
                                      );
                                    })()
                                  ) : (
                                    <p style={{ padding: 10 }}>
                                      No document available
                                    </p>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>
                      <CardFooter className="bg-transparent pt-0">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/srdashboard1"
                          >
                            Cancel
                          </Button>
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            <ProductItemHistoryLog />
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="MRLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { srRowData, reqrowdata, loading } = state.Servicerequest;
  return { srRowData, reqrowdata, loading };
};

export default connect(mapStatetoProps, {
  getReqestRowDetails,
  productItemHistoryModelOpen,
})(MyServiceRequest);
